import {
  forty,
  sixty,
  onetwenty,
  oneighty,
  twoforty,
  others
} from './constants';

export const illustrationsSet = [
  ...forty,
  ...sixty,
  ...onetwenty,
  ...oneighty,
  ...twoforty,
  ...others
];


// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/Illustrationset.js